import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "experience-list" }
const _hoisted_2 = { class: "item-header" }
const _hoisted_3 = { class: "item-info" }
const _hoisted_4 = { class: "item-name" }
const _hoisted_5 = { class: "item-subname" }
const _hoisted_6 = { class: "item-date" }
const _hoisted_7 = {
  key: 0,
  class: "item-detail"
}

import { content } from "@/content/data";

export default /*@__PURE__*/_defineComponent({
  __name: 'Experience',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", null, [
    _cache[0] || (_cache[0] = _createElementVNode("span", { class: "section-title" }, "Work Experience", -1)),
    _createElementVNode("ul", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(content).experience, (job, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: index,
          class: "bulleted-item"
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(job.role), 1),
              _createElementVNode("span", _hoisted_5, _toDisplayString(job.company), 1)
            ]),
            _createElementVNode("span", _hoisted_6, _toDisplayString(job.duration), 1)
          ]),
          (job.description)
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(job.description), 1))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ])
  ]))
}
}

})